import * as z from "zod";

export const saveContextualPixelConfig = {
  name: "saveContextualPixelConfig" as const,
  input: z.object({ gtmContainerId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
